export const HOST_DEFAULT_FEATURE_FLAG_CONFIGS = {
  configs: {
    featureFlagConfigs: {
      translations: true,
      recordWidgets: true,
      useTypeBasedApi: false,
    },
  },
};

const getDefaultFeatureFlagConfigs = () => HOST_DEFAULT_FEATURE_FLAG_CONFIGS.configs.featureFlagConfigs;

let runtimeFeatureFlagConfigs = null;

export const setRuntimeFeatureFlagConfigs = configs => {
  runtimeFeatureFlagConfigs = configs;
};

export const resetRuntimeFeatureFlagConfigs = () => {
  runtimeFeatureFlagConfigs = null;
};

export const getRuntimeFeatureFlagConfigs = () => runtimeFeatureFlagConfigs ?? getDefaultFeatureFlagConfigs();

export const isFeatureEnabledFromConfigs = (configs, featureKey) => {
  const value = configs?.[featureKey];
  return !!value;
};

export const isFeatureEnabled = featureKey => isFeatureEnabledFromConfigs(getRuntimeFeatureFlagConfigs(), featureKey);

export default {
  manageTranslation: true, // to be activated after API and message channel Integration
  exportRecordsEnabled: false,
};
